<template>
  <div style="text-align: center">
    <br><br>
    <h1>{{ privacy_text }}</h1>
    <h5>Last updated: <span style="opacity: 0.6">December 2025</span></h5>
    <div class="title">1. Data Controller</div>
    <div class="description">This privacy policy applies to the UPAYS service provided by:</div>
    <br>
    <textarea style="border: none;background-color: black;color: white" rows="6" cols="60" disabled>

    ulip OÜ
    VAT ID: EE102153321
    Reg.no: 14627808
    Sepapaja tn 6, 15551 Tallinn, Harju maakond Estonia
  </textarea>
    <div class="title">2. Information we collect</div>
    <div class="description">
      <b>Personal data :</b> payment information processed via a STRIPE secure server<br>
      <b>Content data :</b> application web URL, payment page configuration data (monthly fee / one-time fee, flag SHA256 code generation) <br>
      <b>Statistical data :</b> clicks on the payment page, payment counter, accumulated amount / client
    </div>
    <div class="title">3. How We Use Your Information</div>
    <div class="description">
      Personal data is not used by our system.<br>
      Content data is used to generate a web link and configure the corresponding payment page<br>
      Statistical data is used for the logging system and the troubleshooting system.
    </div>
    <div class="title">4. Data retention</div>
    <div class="description">
      Content data : Retained while your account is active<br>
      Statistical data : Retained while your account is active<br>
      Logs data: Retained for up to 3 months for service improvement
    </div>
    <div class="title">5. GDPR</div>
    <div class="description"> Under European data protection law, you have the right to:<br>
      Access, Rectify and Erase You account content data.<br>
      Our service make available this
      <button style="color: #fa755a" @click="gotoPrivate">private link</button>
      that deactivate or erase an account.[ Your Access Code is requested ]<br>
      We do not process personal data from accounts and do not transfer (sell) data to third parties.
    </div>
    <div class="title">6. Data Security</div>
    <div class="description"> We implement appropriate technical measures to protect your data, including encryption and
      secure servers.<br>
      Our service is hosted on Heroku cloud servers.
    </div>
    <div class="title">7. Contact Us</div>
    <div class="description">For any privacy-related questions or to exercise your rights, please contact us through our
      support channel.
    </div>
    <br>
    <button class="close" @click="this.$router.go(-1)">Back</button>
    <br><br>
  </div>
</template>
<script>
export default {
  name: 'Privacy',
  data() {
    return {
      privacy_text:''
    }
  },
  mounted() {
    this.privacy_text = "Privacy Policy"
    window.scroll(0,0)
  },
  methods: {
    gotoPrivate(){
      this.$router.push('/erase')
    }
  }
}
</script>
<style scoped>
@import "../assets/buttons.css";
 .description {
   font-size: 20px;
   font-family: "Apple Symbols",fantasy;
 }
 .title {
   font-weight: bold;
   color: crimson;
   margin-top: 10px;
   margin-bottom: 15px;
   font-size: 25px;
 }
 @media (max-width: 430px) {
   .title {
     font-size: 15px;
   }
   h3 {
     font-size: 13px;
   }
   .description {
     font-size: 14px;
   }
   textarea {
     width: 100%;
     font-size: 8px;
   }
 }
</style>